// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import myAccountFilterSectionStyles from "@conklin/App/SharedStyles/MyAccountPages/List/MyAccountFilterSectionStyles";
import IconSearch from "@conklin/XDL/Icons/IconSearch";
import { mergeWithCss, xScreen } from "@conklin/XDL/Utilities";
import { userListHeaderStyles } from "@insite/content-library/Widgets/UserList/UserListHeader";
import { css } from "styled-components";

userListHeaderStyles.searchGridItem = {
    width: [12, 12, 8, 6, 6],
    css: css`
        ${xScreen("lte", "sm")} {
            order: 2;
            padding-top: 8px;
        }
    `,
};

userListHeaderStyles.buttonsGridItem = {
    width: [2, 2, 4, 3, 3],
    css: css`
        justify-content: flex-end;
        padding-top: 22px;
    `,
};

userListHeaderStyles.searchContainer = {
    gap: 0,
};

userListHeaderStyles.wrapper = {
    css: css`
        margin-bottom: 0;
    `,
};

userListHeaderStyles.searchTextField = {
    cssOverrides: {
        formField: css`
            flex: 1 1 auto;
            margin-right: 16px;
        `,
    },
    iconProps: { src: IconSearch },
};

userListHeaderStyles.userCountGridItem = {
    ...mergeWithCss(myAccountFilterSectionStyles.countGridItem, {
        css: css`
            ${xScreen("lte", "sm")} {
                order: 1;
                justify-content: start;
                padding-bottom: 0;
            }
        `,
    }),
    width: [12, 12, 4, 6, 6],
};
